import { useNavigate } from "react-router-dom";
import styles from "./BookingHome.module.css";
import ControllerOn from "../../assets/images/ControllerOn.jpg";
import ControllerOff from "../../assets/images/ControllerOff.png";
import { useSelector } from "react-redux";
import RecentBookingWidget from "../../widget/RecentBooking/RecentBookingWidget";

const BookingHome = () => {
  const { firstName } = useSelector((state) => state.userInfoSlice);
  const navigate = useNavigate();

  const bookSlot = () => {
    if (firstName) {
      navigate("/booking-form");
    } else {
      navigate("/login");
    }
  };

  const onMyRecentBookingClick = () => {
    if (firstName) {
      navigate("/my-booking-history");
    } else {
      navigate("/login");
    }
  }

  const onSearchBookingClick = () => {
    if (firstName) {
      navigate("/search-booking");
    } else {
      navigate("/login");
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.controllerContainer} onClick={bookSlot}>
        <img
          src={ControllerOn}
          className={`${styles.controller} ${styles.front} ${styles.ControllerOn}`}
          alt="Controller Front"
        />
        <img
          src={ControllerOff}
          className={`${styles.controller} ${styles.front} ${styles.ControllerOff}`}
          alt="Controller Front"
        />
        <span className={styles.neonText}>Book Slot</span>
      </div>
      <div className={`${styles.secContainer}`}>
        <div className={`${styles.bookingContainer}`}>
          <div className={styles.myBookings} onClick={onMyRecentBookingClick}>
            <RecentBookingWidget />
          </div>
          <div className={styles.myBookings} onClick={onSearchBookingClick}>
            Search Bookings
          </div>
        </div>
        <div className={styles.bookTournament}>Book for Tournament</div>
      </div>
    </div>
  );
};

export default BookingHome;
